module.exports = {
    VERSION: '2.3.0'
}
